var finansudd = finansudd || {};

finansudd.ctabanner = new function() {

	var self = this;

	this.init = function () {

		var $closeTrigger = $('.cta-banner .cta-close'),
			$ctabanner = $('.cta-banner');

		// Check if the cookie it true, when add class to cta-banner
		if ($.cookie('fixed-cta') != 'false') {
			$ctabanner.addClass('fixed');
			$ctabanner.addClass('not-shown');
		}

		// On-Click on the close-button
		$closeTrigger.click(function() {

			$ctabanner.removeClass('fixed'); // Remove class
			$.cookie('fixed-cta', 'false', { expires: 1, path: '/' }); // Update cookie

		});

	};

}